import { citiesOptions, stateOptions, ufOptions } from "./customOptions";

export const findCity = (cityValue: string) => {
	const statesKeys = Object.keys(citiesOptions);
	const city = statesKeys.map(stateKey => {
		const cities = citiesOptions[stateKey];
		const result = cities.find(city => {
			return city.value === cityValue;
		});
		if (result){
			return result;
		}
	})[0]

	return city as { label: string; value: string };
}

export const findState = (stateValue: string) => {
	const state = stateOptions.find(state => {
		return state.value === stateValue;
	})

	return state as { label: string; value: string };
}

export const findUF = (UFValue: string) => {
	const UF = ufOptions.find(UF => {
		return UF.value === UFValue;
	})

	return UF as { label: string; value: string };
}


